<template>
  <header class="main-header">
      <div class="container">
          <div class="main-header__inner-wrapper">
              <div class="main-header__inner-wrapper--item">
                  <a href="#">
                      <img v-if="eventLogoUrl" :src="eventLogoUrl" :alt="event.name">
                  </a>
              </div><!-- /.main-header__inner-wrapper--item -->
              <div class="main-header__inner-wrapper--item">
                  <a href="#">
                      <img src="@/assets/images/logos/forum-events.svg" alt="Forum Events">
                  </a>
              </div>
         </div>
      </div>
      <div v-if="attendee" class="main-header__nav-wrapper">
          <div class="container">
              <nav class="main-header__nav">
                  <ul class="main-header__nav-list">
                       <li v-if="chat && chat.loaded"><a class="pubble-cw-contactbot" :data-app-id="chat.appId" :data-app-identifier="chat.appId" :data-user-name="attendee.name" :data-user-email="attendee.email" data-user-type="Account" href="javascript:;">CONTACT THE ORGANISER</a></li>
                       <li v-if="showFloorPlan"><a data-fancybox data-type="iframe" :data-src="event.floor_plan_url" href="javascript:;">FLOOR PLAN</a></li>
                       <li v-if="true"><a data-fancybox data-type="iframe" :data-src="eventGuideSrc" href="javascript:;">EVENT GUIDE</a></li>
                       <li><a data-fancybox data-src="#virtual_attendee_faq" href="javascript:;">VIRTUAL ATTENDEE FAQ</a></li>
                       <li><a data-fancybox data-src="#live_attendee_faq" href="javascript:;">LIVE ATTENDEE FAQ</a></li>
                      <li><NotificationsDropdown/></li>
                      <li v-if="delegateInformation" class="mobile-only"><a data-fancybox data-src="#delegate_information" href="javascript:;">DELEGATE INFORMATION</a></li>
                      <li class="mobile-only"><a @click.prevent="signOut" href="#">SIGN OUT</a></li>
                      <li class="mobile-only" v-if="showInstallApp"><a @click.prevent="installApp" href="#">INSTALL APP</a></li>
                      <li class="desktop-only dropdown">
                        <a class="hamburger-button" href="#" @click.prevent="toggleDropdown">&#9776;</a>
                        <div class="dropdown-content" v-show="showDropdown">
                            <a v-if="delegateInformation" data-fancybox data-src="#delegate_information" href="javascript:;">DELEGATE INFORMATION</a>
                            <a @click.prevent="signOut" href="#">SIGN OUT</a>
                        </div>
                      </li>


                  </ul>
              </nav>
          </div>
      </div>

      <VirtualAttendeeFAQ v-if="attendee"/>
      <LiveAttendeeFAQ v-if="attendee"/>
      <DelegateInformation v-if="delegateInformation"/>
  </header>
</template>


<script>
import VirtualAttendeeFAQ from './VirtualAttendeeFAQ'
import LiveAttendeeFAQ from './LiveAttendeeFAQ'
import NotificationsDropdown from './NotificationsDropdown'
import { mapState } from 'vuex'
import DelegateInformation from "@/components/DelegateInformation.vue";

export default {
  name: 'MainHeader',
  data() {
    return {
      showDropdown: false,
      showInstallApp: (
        !(!!("standalone" in window.navigator && window.navigator.standalone) || // IOS (TODO: detect iPad 13)
          !!window.matchMedia("(display-mode: standalone)").matches) // Android and Desktop Chrome/Safari/Edge
        &&
        (window.location.origin.includes('localhost') || window.location.origin.includes('attendee2'))
      )
    }
  },
  components: {DelegateInformation, VirtualAttendeeFAQ, LiveAttendeeFAQ, NotificationsDropdown},
  computed: {
    ...mapState(['event', 'attendee', 'chat', 'delegateInformation']),
    eventLogoUrl() {
      try {
        return require('@/assets/images/logos/' + this.event.name + '.png')
      } catch (error) {
        return null
      }
    },
    eventGuideSrc() {
      if (this.event.event_guide_embed_code) {
        return window.jQuery(this.event.event_guide_embed_code).find("iframe").attr("src")
      } else {
        return null
      }
    },
    showFloorPlan() {
      return this.event.floor_plan_url && !this.attendee.attending_online
    }
  },
  methods: {
    signOut() {
      this.$emit('signOut');
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    installApp() {
      window.AddToHomeScreenInstance.clearModalDisplayCount()
      window.AddToHomeScreenInstance.show('en')
    }
  }
}
</script>

<style lang="scss" scoped>
    @import 'include-media/dist/_include-media.scss';

    .main-header__nav-list li {
      .hamburger-button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          font-size: 30px;
          font-weight: bold;
      }

      .dropdown-content {
          position: absolute;
          background-color: #f9f9f9;
          min-width: 230px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
          z-index: 1;
          left: -230px;
          top: 30px
      }

      .dropdown-content a {
          padding: 12px 16px;
          text-decoration: none;
          display: block;
          font-size: 19px;
          font-weight: bold;
          color: #000000;
      }

      .dropdown-content a:hover {
          background-color: #ddd;
      }

      .dropdown-content.show {
          display: block;
      }

      &.dropdown {
        position: relative;
        display: inline-block;
      }

      &.desktop-only {
        @include media('<=768px') {
          display: none;
        }
      }
      &.mobile-only {
        @include media('>768px') {
          display: none;
        }
      }
    }
</style>
